<template>
  <div class="create-success">
    <div class="success-title">
      <!--账号创建成功-->
      <div class="title-style">{{ $t('userManage.AccountCreationSuccessful') }}</div>
      <!--请立即导出本次创建的登录账号和初始密码。-->
      <div style="font-size: 14px">{{ $t('userManage.PleaseExportTheLoginAccountAndInitialPasswordCreatedThisTimeImmediately') }}</div>
    </div>
    <div style="margin: 20px 0">
      <div class="success-container">
        <div class="success-icon">
          <i class="el-icon-check" style="color:#0db35b;font-size: 50px" />
        </div>
      </div>
      <!--个临时工账号创建成功-->
      <div class="title-style" style="text-align: center;">{{ createData.createdCount }} {{ $t('userManage.temporaryWorkerAccountsHaveBeenSuccessfullyCreated') }}</div>
      <!--账号已创建并立即生效，将按照各自设置的有效天数自动失效。-->
      <div style="text-align: center;font-size: 14px;">{{ $t('userManage.TheAccountHasBeenCreatedAndWillTakeEffectImmediately') }}</div>
    </div>
    <div class="warning-container">
      <div class="warning-icon">
        !
      </div>
      <div>
        <!--账号和初始密码仅本次可查看和导出-->
        <div style="font-weight: bold;color: #000">{{ $t('userManage.TheAccountAndInitialPasswordCanOnlyBeViewedAndExportedThisTime') }}</div>
        <div>{{ $t('userManage.ForAccountSecurity') }}</div>
      </div>
    </div>
    <div style="padding: 20px">
      <el-row :gutter="20" style="margin-bottom: 20px;">
        <el-col :span="6">
          <div class="create-batch">
            <!--创建批次-->
            <div style="font-size: 12px">{{ $t('userManage.CreateBatch') }}</div>
            <div class="create-data">{{ createData.batchNo }}</div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="create-batch">
            <!--创建账号数-->
            <div style="font-size: 12px">{{ $t('userManage.NumberOfAccountsCreated') }}</div>
            <div class="create-data">{{ createData.createdCount }}</div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="create-batch">
            <!--创建人-->
            <div style="font-size: 12px">{{ $t('userManage.creator') }}</div>
            <div class="create-data">{{ createData.createUserName }}</div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="create-batch">
            <!--创建时间-->
            <div style="font-size: 12px">{{ $t('GlobalSetObj.CreationTime') }}</div>
            <div class="create-data">{{ createData.createTime }}</div>
          </div>
        </el-col>
      </el-row>
      <div class="create-result-container">
        <!--本次创建结果预览-->
        <div class="result-title">
          {{ $t('userManage.PreviewOfTheCreationResult') }}</div>
        <el-table :data="createData.createdRows" max-height="300">
          <!--姓名-->
          <el-table-column :label="$t('collectionCenter.compellation')" prop="realName" />
          <el-table-column label="CPF" prop="cpf" />
          <!--所属转运中心-->
          <el-table-column :label="$t('collectionCenter.owningTransitCenter1')" prop="hubCode" />
          <!--登录账号-->
          <el-table-column :label="$t('userManage.LoginAccount')" prop="username" />
          <!--初始密码-->
          <el-table-column :label="$t('userManage.InitialPassword')" prop="password" />
          <!--岗位-->
          <el-table-column :label="$t('home.position')" prop="positionName" />
          <!--账号有效天数-->
          <el-table-column :label="$t('userManage.NumberOfDaysTheAccountIsValid')" prop="validDays" />
        </el-table>
        <div class="export-title">{{ $t('userManage.ATotalOf') }} {{ createData.createdCount }}
          {{ $t('userManage.items') }}，{{ $t('userManage.ThisPageOnlyDisplaysSomeExamples') }}</div>
      </div>
      <div class="export-account">
        <!--导出账号和密码-->
        <div style="font-size: 14px;font-weight: bold;color:#000;">{{ $t('userManage.ExportAccountAndPassword') }}</div>
        <!--导出的 Excel 将包含：姓名、CPF、所属转运中心、登录账号、初始密码、岗位、账号有效天数、创建人、创建时间。请仅提供给有权限的现场负责人。-->
        <div style="font-size: 12px;margin-bottom: 10px;">{{
          $t('userManage.TheExportedExcelFileWillInclude')
        }}</div>
        <!--一次性导出账号和密码-->
        <div>
          <el-button
            icon="el-icon-bottom" size="small" type="primary"
            @click="downloadModel"
          >{{ $t('userManage.ExportAccountAndPasswordAtOnce') }}</el-button>
        </div>
      </div>
    </div>
    <div class="submit-container">
      <!--建议确认导出成功后再离开本页面。-->
      <div style="flex: 1;font-size: 14px">
        {{ $t('userManage.recommendedConfirmThatTheExportHasBeenSuccessfulBeforeLeavingThisPage') }}
      </div>
      <div style="flex: 1;text-align: right;">
        <!--完成并返回账号列表-->
        <el-button type="primary" @click="uploadVerification">{{ $t('userManage.CompleteAndReturnTheAccountList') }}</el-button>
      </div>
    </div>
    <el-dialog
      :title="$t('userManage.ConfirmAndReturnToAccountList')"
      :visible.sync="showConfirmTips"
      width="800px"
      :append-to-body="true"
    >
      <div>
        <div class="tips-container">
          <div v-if="isDownload === 0" style="font-weight: bold">{{ $t('userManage.TheAccountsAndInitialPasswords') }}</div>
          <div v-else style="font-weight: bold;color: #00a551">{{ $t('userManage.AccountAndPasswordHaveBeenExported') }}</div>
          <div>{{ $t('userManage.AfterLeavingThisPage') }}</div>
        </div>
        <div>{{ $t('userManage.UponReturning') }}</div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showConfirmTips = false">{{ $t('GlobalSetObj.cancel') }}</el-button>
        <el-button type="primary" @click="confirmStillReturn">{{ $t('userManage.StillReturn') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { setHttpTurnHttps } from '@/utils/tools';

export default {
  name: 'CreatedSuccess',
  props: {
    siteIdList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    createData: {
      type: Object,
      default: () => {
        return {
          batchId: null,
          batchNo: null,
          createTime: null,
          createUserName: null,
          createdCount: 0,
          createdRows: [],
          credentialFileUrl: null,
          errorMsg: null,
          failedCount: 0,
          failedRows: [],
          totalCount: 0
        };
      }
    }
  },
  data() {
    return {
      showConfirmTips: false,
      isDownload: 0
    };
  },
  methods: {
    // 下载账号密码
    downloadModel() {
      const link = document.createElement('a');
      link.href = setHttpTurnHttps(this.createData.credentialFileUrl);
      link.download = this.createData.batchNo + '.xlsx'; // 指定文件名
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      this.isDownload += 1;
    },
    // 打开弹窗
    uploadVerification() {
      this.showConfirmTips = true;
    },
    // 确认返回
    confirmStillReturn() {
      this.$emit('closeWindow', true);
    }
  }
};
</script>
<style scoped>
.tips-container {
  border: 1px solid #f3debb;
  border-radius: 10px;
  background:#fff8ee;
  padding: 20px;
  color:#7b5d2c;
  margin-bottom: 10px;
}
.create-success {
  background:#fff;
  border-radius: 10px;
  border: 1px solid #ddd;
}
.success-title {
  border-bottom: 1px solid #ccc;
  padding: 15px 20px;
}
.title-style {
  font-size: 17px;
  font-weight: bold;
  color:#000;
}
.success-container {
  display:flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
}
.success-icon {
  background:#eaf8f0;
  border-radius: 50%;
  width: 70px;
  height: 70px;
  display:flex;
  align-items: center;
  justify-content: center;
}
.warning-container {
  display: flex;
  border: 1px solid #f3debb;
  border-radius: 10px;
  padding: 10px;
  font-size: 14px;
  background:#fff8ee;
  color: #7b5d2c;
  margin: 0 20px;
}
.warning-icon {
  width: 40px;
  height: 40px;
  display:flex;
  align-items: center;
  justify-content: center;
  background: #ffedd5;
  color: #d87771;
  font-size: 20px;
  border-radius: 10px;
  margin-right: 5px;
}
.create-batch {
  border-radius: 10px;
  border: 1px solid #ddd;
  padding: 20px;
}
.create-data {
  font-size: 18px;
  font-weight: bold;
  color:#000;
}
.create-result-container {
  border: 1px solid #ddd;
  border-radius: 10px;
  margin-bottom: 20px;
}
.result-title {
  background:#f8fafc;
  font-weight: bold;
  font-size: 14px;
  padding: 10px;
  border-bottom: 1px solid #ddd;
  border-radius: 10px 10px 0 0;
}
.export-title {
  text-align: center;
  font-size: 12px;
  padding: 10px;
}
.export-account {
  border: 1px solid #cdead9;
  border-radius: 10px;
  padding: 20px;
  background:#fafffc;
}
.submit-container {
  display: flex;
  align-items: center;
  padding: 20px;
  border-top: 1px solid #ddd;
}
</style>
